import { render, staticRenderFns } from "./categoryComponent.vue?vue&type=template&id=6b7d674e&scoped=true"
import script from "./categoryComponent.vue?vue&type=script&lang=js"
export * from "./categoryComponent.vue?vue&type=script&lang=js"
import style0 from "./categoryComponent.vue?vue&type=style&index=0&id=6b7d674e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7d674e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\new-tis\\FR-TISSOT-IFB-Discovery-SFCC\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b7d674e')) {
      api.createRecord('6b7d674e', component.options)
    } else {
      api.reload('6b7d674e', component.options)
    }
    module.hot.accept("./categoryComponent.vue?vue&type=template&id=6b7d674e&scoped=true", function () {
      api.rerender('6b7d674e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "cartridges/int_guidedProductFinder/cartridge/client/default/js/components/categoryComponent.vue"
export default component.exports